import React from "react";
import { Break } from "~/components-shared";
import styled from "styled-components";
import InputSlackMemberSelectControl from "~/components/InputSlackMemberSelectControl";
import InputSlackChannelSelectControl from "~/components/InputSlackChannelSelectControl";
const Fieldset = styled.fieldset`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const ShareInSlackForm = _ref => {
  let {
    control
  } = _ref;
  return /*#__PURE__*/React.createElement(Fieldset, null, /*#__PURE__*/React.createElement(InputSlackMemberSelectControl, {
    name: "slackUserIds",
    control: control,
    s: {
      mb: 3
    },
    multiple: true,
    fullSelections: true
  }), /*#__PURE__*/React.createElement(Break, {
    s: {
      mb: 3
    }
  }, "or"), /*#__PURE__*/React.createElement(InputSlackChannelSelectControl, {
    name: "slackChannelIds",
    label: "Select one or multiple Slack channels",
    control: control,
    multiple: true,
    fullSelections: true
  }));
};
export default ShareInSlackForm;